

import { getUser, getUserInfo } from "../config/authsave";

/**
 * ตรวจสอบสิทธิ์โดยอ้างอิงจาก User Role
 * @param {string} type - ชนิดการตรวจสอบ
 */
export const CheckPermission = (type) => {
  const userRole = getUser()?.role;
  if (!userRole) return false;

  // กำหนดกลุ่ม Role ที่ได้รับอนุญาต
  const ROLES = {
    OWNERS: ["SuperOwner", "Subowner"],
    WITH_AUDITOR: ["SuperOwner", "Subowner", "Cs ( Auditor )"]
  };

  // Mapping ระหว่าง Action และ กลุ่ม Role
  const permissionMap = {
    viewMerchant: ROLES.WITH_AUDITOR,
    viewPermission: ROLES.OWNERS,
    view_add_role_permissions: ROLES.OWNERS,
    add_admin_view_role: ROLES.OWNERS,
    setFees: ROLES.OWNERS,
    AddMemerchang: ROLES.OWNERS,
  };

  const allowedRoles = permissionMap[type] || [];
  return allowedRoles.includes(userRole);
};

/**
 * ตรวจสอบสิทธิ์โดยอ้างอิงจาก Admin Type
 * @param {string} type - ชนิดการตรวจสอบ
 */
export const CheckAdminType = (type) => {
  const userRole = getUserInfo()?.admin_type;
  if (!userRole) return false;

  // กำหนดกลุ่มสิทธิ์ล่วงหน้าเพื่อลดความซ้ำซ้อน
  const GROUP_CORE = ["programer", "superadmin"];
  const GROUP_FULL = ["programer", "superadmin", "agent"];

  const adminTypeMap = {
    selectTypeAdmin: GROUP_CORE,
    setFees: GROUP_CORE,
    addmerchant: GROUP_FULL,
    setTransFee: GROUP_FULL,
    viewMerchant: GROUP_FULL,
    add_admin_view_role: GROUP_FULL,
  };

  const allowedRoles = adminTypeMap[type] || [];
  return allowedRoles.includes(userRole);
};

/**
 * ตรวจสอบ Admin Type ทั่วไป 
 */
export const CheckTypeAdmin = (item) => {
  if (!item?.admin_type) return false;
  return ["programer", "superadmin", "agent"].includes(item.admin_type);
};

/**
 * ตรวจสอบสิทธิ์ Admin แบบมีเงื่อนไขพิเศษ (Username/MerchantId)
 */
export const checkTypeAdminNomal = (item) => {
  if (!item) return false;

  const { admin_type, username, merchantId } = item;
  
  const superRoles = ["programer", "superadmin"];
  const specialUsernames = ["snt498", "snt499"];
  const specialMerchants = [46, 62];

  if (superRoles.includes(admin_type)) return true;

  if (specialMerchants.includes(merchantId)) {
    // ถ้าเป็นร้านค้าพิเศษ ต้องเป็น admin และ username ที่ระบุเท่านั้น
    return admin_type === "admin" && specialUsernames.includes(username);
  }

  return true;
};